/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Description_Job_TypeInputs */

const en_scene_description_job_type = /** @type {(inputs: Scene_Description_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot Description`)
};

const fr_scene_description_job_type = /** @type {(inputs: Scene_Description_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description du plan`)
};

const de_scene_description_job_type = /** @type {(inputs: Scene_Description_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schussbeschreibung`)
};

const it_scene_description_job_type = /** @type {(inputs: Scene_Description_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione dell'inquadratura`)
};

const ru_scene_description_job_type = /** @type {(inputs: Scene_Description_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание кадра`)
};

const es_scene_description_job_type = /** @type {(inputs: Scene_Description_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción de la toma`)
};

const zh_cn2_scene_description_job_type = /** @type {(inputs: Scene_Description_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`镜头描述`)
};

const ja_scene_description_job_type = /** @type {(inputs: Scene_Description_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撮影内容の説明`)
};

const hi_scene_description_job_type = /** @type {(inputs: Scene_Description_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट का विवरण`)
};

const pt_pt2_scene_description_job_type = /** @type {(inputs: Scene_Description_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição da cena`)
};

/**
* | output |
* | --- |
* | "Shot Description" |
*
* @param {Scene_Description_Job_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_job_type = /** @type {((inputs?: Scene_Description_Job_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Job_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_description_job_type(inputs)
	if (locale === "de") return de_scene_description_job_type(inputs)
	if (locale === "it") return it_scene_description_job_type(inputs)
	if (locale === "ru") return ru_scene_description_job_type(inputs)
	if (locale === "es") return es_scene_description_job_type(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_description_job_type(inputs)
	if (locale === "ja") return ja_scene_description_job_type(inputs)
	if (locale === "hi") return hi_scene_description_job_type(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_description_job_type(inputs)
	return en_scene_description_job_type(inputs)
});